import { defineElement, FC } from '@atomify/hooks';
import { h } from '@atomify/jsx';

const Loader: FC = () => (
    <div class="c-loader">
        <div class="loader__ball"></div>
        <div class="loader__ball"></div>
        <div class="loader__ball"></div>
    </div>
);

defineElement('bpd-loader', Loader);
